import {ThemeColorPath} from 'platform/foundation';
import {match} from 'ts-pattern';

export function getAdvertisementVehicleBackgroundColor(params: {
  isMyVehicle: boolean;
  isMyAd: boolean;
  isPricingNeighbour?: boolean;
}): ThemeColorPath | undefined {
  return match(params)
    .with({isMyVehicle: true}, () => 'palettes.teal.20.100' as const)
    .with({isMyAd: true}, () => 'palettes.green.10.100' as const)
    .with({isPricingNeighbour: true}, () => 'palettes.red.20.100' as const)
    .otherwise(() => undefined);
}
